export var returnWrapper=function(awaitable){return{promise:awaitable||Promise.resolve()}};